import { useEffect, useRef } from "react";
import { createPluginUI } from "molstar/lib/mol-plugin-ui";
import { renderReact18 } from "molstar/lib/mol-plugin-ui/react18";
import { PluginUIContext } from "molstar/lib/mol-plugin-ui/context";
import "molstar/lib/mol-plugin-ui/skin/light.scss";
import { TextBackground, CustomLink } from "../components";


declare global {
  interface Window {
    molstar?: PluginUIContext;
  }
}

export const MolstarViewer = () => {
const commonWidth = "80%";
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    async function init() {
      if (!containerRef.current) return;

      window.molstar = await createPluginUI({
        target: containerRef.current,
        render: renderReact18,
      });

      const data = await window.molstar.builders.data.download(
        { url: "https://files.rcsb.org/download/1AO7.pdb" },
        { state: { isGhost: true } }
      );

        // TODO: load in raw data from DB...

        // const data = await window.molstar.builders.data.rawData(
        //     {data: fileContent},
        //     { state: { isGhost: true } }
        //   );

      const trajectory = await window.molstar.builders.structure.parseTrajectory(data, "pdb");

      await window.molstar.builders.structure.hierarchy.applyPreset(
        trajectory,
        "default"
      );
    }

    init();

    return () => {
      window.molstar?.dispose();
      window.molstar = undefined;
    };
  }, []);

  return (
    <section className="page">
      <TextBackground width={commonWidth}>
        <div
          ref={containerRef}
          style={{
            aspectRatio: "1 / 1",
            width: "100%",
            position: "relative",
            overflow: "hidden",
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginBottom: "2rem"
          }}
          className="molstar-embed"
        />

        <h2>Structure Description</h2>
        <div>
          <p>
            At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat
          </p>
        </div>
      </TextBackground>
    </section>
  );
};